<template>
    <div class="animated fadeIn" id="data">
        <ValidationObserver ref="observer" v-slot="{ invalid }">
            <div v-if="loading">
                <b-row>
                    <b-col md="6">
                        <atom-spinner
                            :animation-duration="1000"
                            :size="60"
                            color="#ff1d5e"
                            class="float-right my-4"
                        />
                    </b-col>
                </b-row>
            </div>
            <b-row v-if="!loading">
                <b-col sm="12">
                    <b-card
                        class="full-width"
                        border-variant="info"
                        header-bg-variant="white"
                        header-class="header-font"
                    >
                        <div slot="header">
                            <strong v-if="$route.name !== 'ViewAttribute'"
                                >{{ concern[context] }} Attribute</strong
                            >
                            <strong v-else>View Attribute</strong>
                            <router-link to="/attribute">
                                <eb-button
                                    style="float: right"
                                    classic="mr-1 btn-primary"
                                    text="Back"
                                ></eb-button>
                            </router-link>
                        </div>
                        <b-row>
                            <b-col sm="6">
                                <ValidationProvider
                                    rules="required"
                                    v-slot="{ errors }"
                                    name="Field Name"
                                >
                                    <b-form-group>
                                        <label for="name">Field Name</label>
                                        <b-form-input
                                            type="text"
                                            id="name"
                                            v-model="inputObj.attributeName"
                                            placeholder="Enter Field Name"
                                        ></b-form-input>
                                    </b-form-group>
                                    <span
                                        class="validate-error"
                                        style="color: red"
                                        >{{ errors[0] }}</span
                                    >
                                </ValidationProvider>
                            </b-col>
                            <b-col sm="6">
                                <ValidationProvider
                                    rules="required"
                                    v-slot="{ errors }"
                                    name="Type"
                                >
                                    <b-form-group>
                                        <label for="month1">Type</label>
                                        <b-form-select
                                            style="height: 38px"
                                            id="option"
                                            v-model="
                                                inputObj.attributeValueType
                                            "
                                            :options="options"
                                        ></b-form-select>
                                    </b-form-group>
                                    <span
                                        class="validate-error"
                                        style="color: red"
                                        >{{ errors[0] }}</span
                                    >
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="12">
                                <ValidationProvider
                                    rules="required"
                                    v-slot="{ errors }"
                                    name="Description"
                                >
                                    <b-form-group>
                                        <label for="ccnumber"
                                            >Description</label
                                        >
                                        <b-form-input
                                            type="text"
                                            id="description"
                                            v-model="inputObj.description"
                                            placeholder="Short Description"
                                        ></b-form-input>
                                    </b-form-group>
                                    <span
                                        class="validate-error"
                                        style="color: red"
                                        >{{ errors[0] }}</span
                                    >
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <ValidationProvider
                                    rules="required"
                                    v-slot="{ errors }"
                                    name="Language"
                                >
                                    <v-select
                                        v-model="selectedLanguage"
                                        @change="onChangeLang"
                                        :items="languages"
                                        item-text="name"
                                        return-object
                                        label="Select Language"
                                        multiple
                                        chips
                                        hint="What are the target language"
                                        persistent-hint
                                        ref="langSelect"
                                    >
                                        <template v-slot:prepend-item>
                                            <div class="d-flex justify-end">
                                                <span
                                                    style="
                                                        cursor: pointer;
                                                        font-size: 14px;
                                                        margin-left: 1200px;
                                                        margin-right: 20px;
                                                        margin-top: 10px;
                                                    "
                                                    @click.stop="
                                                        $refs.langSelect.blur()
                                                    "
                                                >
                                                    ✖
                                                </span>
                                            </div>
                                        </template>
                                    </v-select>
                                    <span
                                        class="validate-error"
                                        style="color: red"
                                        >{{ errors[0] }}</span
                                    >
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col
                                md="4"
                                v-for="(item, index) in selectedLanguage"
                                :key="index"
                            >
                                <b-form-group>
                                    <label :for="item.name"
                                        >Field Label {{ item.name }}</label
                                    >
                                    <b-form-input
                                        type="text"
                                        :id="item.name"
                                        v-model="
                                            inputObj.attributeLabel[item.id]
                                        "
                                        :placeholder="`Enter Field Label in ${item.name}`"
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <div class="flex">
                            <div class="form-actions text-center">
                                <eb-button
                                    v-if="$route.name !== 'ViewAttribute'"
                                    classic="mr-1 btn-primary"
                                    text="Save"
                                    @click="handleSubmit"
                                    icon="fas fa-save mr-1"
                                    iconSide="left"
                                ></eb-button>
                            </div>
                        </div>
                    </b-card>
                </b-col>
            </b-row>

            <b-row v-if="isArrayType && !loading">
                <b-col sm="12">
                    <array
                        title="Array Field"
                        :type="arrayType"
                        :currentroute="$route.name"
                        :types="types"
                        @changeType="changeArrayType"
                        @add="addArrayItem"
                        @delete="deleteArrayItem"
                        :items="arrayItems"
                        :objectType="isArrayOfObject"
                    />
                </b-col>
            </b-row>

            <b-row v-if="(complexType || isArrayOfObject) && !loading">
                <b-col sm="12">
                    <attr-form
                        :title="inputObj.attributeName"
                        :inputObj="objectSpec"
                        :typeOptions="subOptions"
                        :inputMethods="{
                            changeType: this.changeType,
                            changeName: this.changeName,
                            changeDesc: this.changeDesc,
                        }"
                        :nameError="$v.objectSpec.attributeName.$error"
                    >
                        <template v-slot:actions>
                            <eb-button
                                classic="mr-1 btn-primary"
                                text="Add"
                                @click="saveInner"
                                icon="fa fa-plus-circle mr-1"
                                iconSide="left"
                            ></eb-button>
                            <eb-button
                                classic="mr-1 btn-primary"
                                text="Reset"
                                @click="resetInner"
                                icon="fas fa-retweet mr-1"
                                iconSide="left"
                            ></eb-button>
                        </template>

                        <template v-slot:members>
                            <b-card
                                class="card-accent-info"
                                header="Sub Attributes"
                                border-variant="info"
                                header-bg-variant="primary"
                                header-text-variant="white"
                            >
                                <div v-show="objectMembers.length > 0">
                                    <b-form-group
                                        label-cols-sm="3"
                                        class="mb-2"
                                    >
                                        <b-input-group>
                                            <b-form-input
                                                v-model="filter"
                                                placeholder="Type to Search"
                                            />
                                            <!-- <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''" class="btn btn-primary">Clear</b-button>
                    </b-input-group-append>-->
                                        </b-input-group>
                                    </b-form-group>
                                    <b-table
                                        :items="objectMembers"
                                        :fields="objectColumns"
                                        :per-page="perPage"
                                        :current-page="currentPage"
                                        :filter="filter"
                                        :bordered="true"
                                        thead-class="header"
                                    >
                                        <template
                                            slot="cell(action)"
                                            slot-scope="data"
                                        >
                                            <b-button
                                                size="sm"
                                                class="mr-2"
                                                variant="danger"
                                                @click="deleteAttribute(data)"
                                            >
                                                <i class="fa fa-trash bin"></i>
                                            </b-button>
                                            <b-button
                                                size="sm"
                                                class="mr-2"
                                                style="
                                                    background: #fe7b08;
                                                    border: #fe7b08;
                                                "
                                                variant="primary"
                                                @click="editAttribute(data)"
                                            >
                                                <i
                                                    class="fa fa-pencil edit"
                                                ></i>
                                            </b-button>
                                        </template>
                                    </b-table>
                                    <nav>
                                        <b-pagination
                                            :total-rows="totalRows"
                                            :per-page="perPage"
                                            v-model="currentPage"
                                            prev-text="Prev"
                                            next-text="Next"
                                            hide-goto-end-buttons
                                        />
                                    </nav>
                                </div>
                                <b-row v-if="!objectMembers.length > 0">
                                    <b-col md="12 mt-2">
                                        <b-alert
                                            v-model="showDismissibleAlert"
                                            variant="info"
                                            dismissible
                                            >Data Not Found</b-alert
                                        >
                                    </b-col>
                                </b-row>
                            </b-card>
                        </template>
                    </attr-form>
                </b-col>
            </b-row>
            <br />
        </ValidationObserver>
    </div>
</template>

<style scoped>
.flex {
    display: flex;
    flex-direction: row-reverse;
}
.form-actions {
    width: max-content;
}
</style>

<script>
import axios from "axios";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, minLength, between } from "vuelidate/lib/validators";
import { createAttibute, update, findByid } from "../../services/attribute.js";
import ArrayForm from "@/components/Attribute/Array";
import AttributeForm from "@/components/Attribute/AttributeForm";
import ebButton from "@/components/FormElements/Button";
import { AtomSpinner } from "epic-spinners";
let { isArray } = Array;

let initState = function () {
    return {
        langObj: {
            en: "English",
            bn: "Bengali",
            te: "Telugu",
            hi: "Hindi",
        },
        showDismissibleAlert: true,
        selected: [],
        show: true,
        filter: "",
        inputObj: {
            attributeName: "",
            description: "",
            attributeValueType: "String",
            attributeLabel: {},
        },
        selectedLanguage: [],
        languages: [
            { id: "en", name: "English" },
            { id: "bn", name: "Bengali" },
            { id: "te", name: "Telugu" },
            { id: "hi", name: "Hindi" },
        ],
        objectSpec: {
            attributeName: "",
            description: "",
            attributeValueType: "String",
        },
        concern: {
            edit: "Edit",
            create: "Create",
            view: "View",
        },
        options: [
            {
                value: "Object",
                text: "Object",
            },
            {
                value: "Array",
                text: "Array",
            },
            {
                value: "String",
                text: "String",
            },
            {
                value: "Number",
                text: "Number",
            },
            {
                value: "Boolean",
                text: "Boolean",
            },
            {
                value: "Image",
                text: "Image",
            },
            {
                value: "Date",
                text: "Date",
            },
        ],
        subOptions: [
            {
                value: "String",
                text: "String",
            },
            {
                value: "Number",
                text: "Number",
            },
            {
                value: "Boolean",
                text: "Boolean",
            },
        ],
        objectMemberIndex: null,
        objectMembers: [],
        currentPage: 1,
        perPage: 10,
        objectColumns: [
            {
                key: "attributeName",
                label: "Field Name",
                sortable: true,
            },
            {
                key: "attributeValueType",
                label: "Type",
                sortable: true,
            },
            {
                key: "description",
                label: "Description",
                sortable: true,
            },
            {
                key: "action",
                label: "Action",
            },
        ],
        arrayType: "Checkbox",
        types: ["Checkbox", "Select", "Radio", "Object"],
        arrayItems: [],
        loading: false,
    };
};

export default {
    name: "createattibute",
    data() {
        return initState();
    },
    validations: {
        objectSpec: {
            attributeName: {
                required,
                minLength: minLength(2),
            },
        },
    },
    computed: {
        complexType: function () {
            return ["Object"].includes(this.inputObj.attributeValueType);
        },
        isArrayType: function () {
            return this.inputObj.attributeValueType === "Array";
        },
        isArrayOfObject: function () {
            return (
                this.inputObj.attributeValueType === "Array" &&
                this.arrayType === "Object"
            );
        },
        context: function () {
            return this.$route.params &&
                this.$route.params.id &&
                this.$route.params.id.length === 24
                ? "edit"
                : "create";
        },
        totalRows: function () {
            return this.objectMembers.length;
        },
        objectMembersSet: function () {
            return new Set(
                this.objectMembers
                    ? this.objectMembers.map((o) => o.attributeName)
                    : [],
            );
        },
        arrayItemsSet: function () {
            return new Set(this.arrayItems.map((i) => i.name));
        },
    },
    methods: {
        async handleSubmit() {
            const isValid = await this.$refs.observer.validate();
            if (!isValid) return;
            if (this.inputObj.attributeLabel.en === "") {
                this.inputObj.attributeLabel.en = this.inputObj.attributeName;
            }
            let payload = {
                ...this.inputObj,
                attributeItems: this.objectMembers,
            };
            // filter Label object with selected Lang.
            if (this.selectedLanguage.length > 0) {
                let keys = Object.keys(this.inputObj.attributeLabel);
                keys.map((key) => {
                    const ifKeyExist = this.selectedLanguage.some(
                        (obj) => obj.id === key,
                    );
                    if (!ifKeyExist) {
                        delete this.inputObj.attributeLabel[key];
                    }
                });
            }
            if (this.isArrayType === true) {
                payload.attributeValueType = "Array";
                payload.UIConcern = this.arrayType;
                if (["Checkbox", "Select", "Radio"].includes(this.arrayType))
                    payload.attributeItems = this.arrayItems.map((a) => ({
                        attributeName: a.name,
                    }));
            }
            if (this.context === "create") {
                await this.$store
                    .dispatch("attribute/createAttribute", payload)
                    .then((result) => {
                        if (result.status === 1) {
                            this.$swal({
                                title: "Congratulation",
                                text: "Attribute has been created Successfully",
                                type: "success",
                            });
                            this.reset();
                            this.$router.push({ path: "/attribute" });
                        }
                    })
                    .catch((error) => {
                        this.$swal({
                            title: "Oops",
                            text: "Attribute has not been saved",
                            type: "error",
                        });
                    });
            } else {
                (delete payload._id, delete payload.createdBy);
                delete payload.createdAt;
                delete payload.updatedAt;
                delete payload.__v;
                const payloadObj = { id: this.$route.params.id, data: payload };
                this.$store
                    .dispatch("attribute/updateAttribute", payloadObj)
                    .then((result) => {
                        if (result.status === 1) {
                            this.$swal({
                                title: "Congratulation",
                                text: "Attribute has been updated Successfully",
                                type: "success",
                            });
                            this.$router.push({ path: "/attribute" });
                        }
                    })
                    .catch((error) => {
                        this.$swal({
                            title: "Oops",
                            text: "Attribute has not been saved",
                            type: "error",
                        });
                    });
            }
        },
        changeSimple(path, value) {
            this.inputObj[path] = value;
        },
        changeInner(path, value) {
            this.objectSpec[path] = value;
        },
        changeName(e) {
            this.changeInner("attributeName", e);
            this.$v.objectSpec.attributeName.$touch();
        },
        changeType(e) {
            this.changeInner("attributeValueType", e);
        },
        changeDesc(e) {
            this.changeInner("description", e);
        },
        saveInner() {
            if (this.$v.$invalid) return;

            let freshMember = { ...this.objectSpec };
            if (this.objectMemberIndex !== null) {
                this.objectMembers = this.objectMembers.map((m, idx) =>
                    idx == this.objectMemberIndex ? freshMember : m,
                );
            } else {
                if (this.objectMembersSet.has(this.objectSpec.attributeName)) {
                    this.$message.error("The field already exists!!");
                    return;
                }
                this.objectMembers = this.objectMembers.concat([freshMember]);
            }
            this.resetInner();
        },
        reset() {
            Object.assign(this.$data, initState());
        },
        resetInner() {
            this.objectSpec = {
                attributeName: "",
                description: "",
                attributeValueType: "String",
            };
            this.objectMemberIndex = null;
        },
        deleteAttribute(data) {
            let { index } = data;
            this.objectMembers = this.objectMembers.filter(
                (m, idx) => idx !== index,
            );
        },
        editAttribute(data) {
            this.objectSpec = this.objectMembers[data.index];
            this.objectMemberIndex = data.index;
        },
        changeArrayType(e) {
            this.arrayType = e;
        },
        addArrayItem(e) {
            if (!(e && e.name && e.name.length > 1)) return;
            if (this.arrayItemsSet.has(e.name)) {
                this.$message.error("The field already exists!!");
                return;
            }
            this.arrayItems.push({ ...e });
        },
        deleteArrayItem(e) {
            this.arrayItems.splice(e, 1);
        },
        onChangeLang(event) {
            //
        },
    },
    async mounted() {
        this.loading = true;
        if (this.context === "edit") {
            await this.$store
                .dispatch("attribute/getAttributeById", this.$route.params.id)
                .catch((error) => {
                    this.$toasted.error(error);
                });
            let result =
                this.$store.getters["attribute/GetCurrentReadAttribute"];
            let { attributeItems, UIConcern, attributeValueType } = result;
            if (attributeValueType === "Array") {
                this.arrayItems = isArray(attributeItems)
                    ? result.attributeItems.map((i) => ({
                          name: i.attributeName,
                      }))
                    : [];
            } else if (attributeValueType === "Object") {
                this.objectMembers = isArray(attributeItems)
                    ? attributeItems
                    : [];
            }
            this.inputObj = result;
            if (!this.inputObj.attributeLabel) {
                this.inputObj.attributeLabel = {
                    en: "",
                    bn: "",
                    te: "",
                };
            } else {
                Object.keys(this.inputObj.attributeLabel).map((obj) => {
                    this.selectedLanguage.push({
                        id: obj,
                        name: this.langObj[obj],
                    });
                });
            }
        }
        this.loading = false;
    },
    components: {
        "attr-form": AttributeForm,
        array: ArrayForm,
        ebButton,
        AtomSpinner,
        ValidationProvider,
        ValidationObserver,
    },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
.edit {
    color: #ffffff !important;
}
.bin {
    color: white !important;
}
.header-font {
    font-weight: 700;
    font-size: medium;
}
.form-actions {
    width: 100%;
    text-align: center;
}
</style>
<style>
.ant-radio-group-solid
    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    background: var(--primary) !important;
    border-color: var(--primary) !important;
    color: #fff;
}
</style>
